if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.bundle = document.querySelector('bundle-component');
      const bundleButton = this.bundle && this.bundle.querySelector('[type="button"]');
      if (bundleButton) {
        bundleButton.addEventListener('click', this.onSubmitBundle.bind(this));
      }
    }

    /*
     * Builds the request body. The theme cart drawer is optional:
     * if it is not on the page (custom JFK header), we simply skip "sections".
     */
    buildBody(formData) {
      const payload = { ...formData };
      const cartDropdown = document.querySelector('cart-dropdown-bubble');

      if (cartDropdown && typeof cartDropdown.getSectionsToRender === 'function') {
        try {
          payload.sections = cartDropdown.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        } catch (error) {
          console.warn('Cart drawer sections skipped:', error);
        }
      }

      return JSON.stringify(payload);
    }

    resetButton(button) {
      if (!button) return;
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      this.submitButton = this.querySelector('[type="submit"]');
      if (!this.submitButton || this.submitButton.classList.contains('loading')) return;

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      try {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const item = JSON.parse(serializeForm(this.form));

        this.formData = { items: [item] };
        this.formQuantity = [];
        this.formQuantity[item.id] = item.quantity;

        config.body = this.buildBody(this.formData);

        // ajaxCart (global.js) adds the item, shows the toast and resets the button.
        ajaxCart(config, this.formQuantity, this.submitButton);
      } catch (error) {
        console.error('Add to cart failed before sending:', error);
        this.resetButton(this.submitButton);
        window.alert('Something went wrong. Please try again.');
      }
    }

    onSubmitBundle(evt) {
      evt.preventDefault();

      this.bundleButton = this.bundle.querySelector('[type="button"]');
      if (!this.bundleButton || this.bundleButton.classList.contains('loading')) return;

      this.bundleButton.setAttribute('aria-disabled', true);
      this.bundleButton.classList.add('loading');

      try {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const item = JSON.parse(serializeForm(this.form));
        const listCheckbox = this.bundle.querySelectorAll('[data-bundle-checkbox]:checked');

        this.formData = { items: [item] };
        this.formQuantity = [];
        this.formQuantity[item.id] = item.quantity;

        Array.from(listCheckbox).forEach((checkbox) => {
          this.formData.items.push({ id: checkbox.value, quantity: 1 });
          this.formQuantity[checkbox.value] = 1;
        });

        config.body = this.buildBody(this.formData);

        ajaxCart(config, this.formQuantity, this.bundleButton);
      } catch (error) {
        console.error('Bundle add to cart failed before sending:', error);
        this.resetButton(this.bundleButton);
        window.alert('Something went wrong. Please try again.');
      }
    }
  });
}